var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-outer"},[_c('Plan_svg'),_c('input',{attrs:{"type":"text","id":"search","placeholder":"Buscar..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }